import { error as logError } from '../utils/logger'
import { apiUrl } from "../config/config"
import { sendRequest } from "../utils/FetchServices"


export interface SaveTrackingsResponse {
    status: number
    response: {
        status: number
        trackinsCreates: number[]
    }
    duration: number
    retries: number
}

export const request_save_trackings = async ({ authToken, body }): Promise<SaveTrackingsResponse> => {
    const URL_SAVE_TRACKINGS = apiUrl + '/save_trackings'
    try {
        const headers = {
            Authorization: authToken,
        }
        const response = await sendRequest(URL_SAVE_TRACKINGS, 'POST', headers, body, 0, 30, null, [], false)
        return response
    } catch (error) {
    logError('TrackingService', 'Error en request_save_trackings:', error)
        throw error
    }
}